exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".VIPI4 {\n  cursor: pointer;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"container": "VIPI4"
};